import Nullstack from 'nullstack';
export default function IconStackPop({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-stack-pop",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M7 9.5l-3 1.5l8 4l8 -4l-2.999 -1.5"
  }), "   ", Nullstack.element("path", {
    d: "M4 15l8 4l8 -4"
  }), "   ", Nullstack.element("path", {
    d: "M12 11v-7"
  }), "   ", Nullstack.element("path", {
    d: "M9 7l3 -3l3 3"
  }), " ");
}